<template>
  <div class="get-away__pricing">
    <div
      v-if="hasDiscount"
      class="get-away__pricing__numerics"
      :class="{left, 'column-desktop': columnDesktop}"
    >
      <div class="get-away__pricing__base-price">
        {{ basePriceStr }}
      </div>
      <div class="get-away__pricing__final-price">
        {{ discountPriceStr }}
      </div>
    </div>
    <div
      v-else
      class="get-away__pricing__numerics"
      :class="{left}"
    >
      <div class="get-away__pricing__final-price">
        {{ basePriceStr }}
      </div>
    </div>
    <div
      v-if="showRateName"
      class="get-away__pricing__type"
    >
      {{ rate.name }}*
    </div>
  </div>
</template>

<script lang="ts">
import type { GetAwayRate } from '~/core/ts/entity/GetAwayAvailability'
import { Money } from '~/core/ts/entity/Money'

export default defineNuxtComponent({
  props: {
    rate: {
      type: Object as PropType<GetAwayRate>,
      required: true,
    },
    showRateName: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    columnDesktop: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const hasDiscount = computed(() => {
      return props.rate.basePrice.amount !== props.rate.basePriceWithDiscount.amount
    })

    const basePriceStr = computed(() => Money.toString(props.rate.basePrice, 2))
    const discountPriceStr = computed(() => Money.toString(props.rate.basePriceWithDiscount, 2))

    return {
      hasDiscount,
      basePriceStr,
      discountPriceStr,
    }
  },
})
</script>

<style lang="scss" scoped>
.get-away{
  &__pricing {
    @apply py-2;

    @apply w-full;

    &__numerics {
      @apply flex;
      @apply items-center;
      @apply justify-center;
      @apply gap-2;
    }

    &__base-price {
      @apply text-lg;
      @apply line-through;
      @apply px-2;
    }

    &__final-price {
      @apply font-bold;

      @apply text-spl-dark;
      @apply text-4xl;
    }

    &__type {
      @apply text-spl-dark;
      @apply text-center;
    }
  }
}
.get-away__pricing__numerics.left {
  @apply items-center;
  @apply justify-end;
}

.get-away__pricing__numerics.column-desktop {
  @screen lg {
    @apply flex-col;
    @apply items-end;
    @apply justify-center;
  }
}
</style>
